const images = [{
        'name': 'coin',
        'scope': 'common',
         'type': 'image',
        'source': require('./common/token.png')
    },{
        'name': 'burger',
        'scope': 'common',
         'type': 'image',
        'source': require('./common/burger.png')
    },{
        'name': 'bed',
        'scope': 'common',
         'type': 'image',
        'source': require('./common/bed.png')
    },{
        'name': 'zzz',
        'scope': 'common',
         'type': 'image',
        'source': require('./common/zzz.png')
    },{
        'name': 'disco1',
        'scope': 'common',
         'type': 'image',
        'source': require('./common/bouleDisco.png')
    },{
        'name': 'disco',
        'scope': 'common',
         'type': 'image',
        'source': require('./common/disco.png')
    }];

export {images};
